import React from 'react'

import {
  ComponentsThemeProvider,
  Icon,
  getCssVariable,
  themeAutomator,
} from '@fourthwall/components'
import { CloseIcon } from '@fourthwall/icons'

import * as S from './styled'

export const Bar = ({ title }: { title?: string }) => {
  const colorPrimary = getCssVariable('--color-primary')
  const colorOnPrimary = getCssVariable('--color-on-primary')
  const colorBackground = getCssVariable('--color-background')
  const colorOnBackground = getCssVariable('--color-on-background')

  return (
    <ComponentsThemeProvider
      automatedTheme={themeAutomator({
        colorBackground,
        colorOnPrimary,
        colorPrimary,
        colorOnBackground,
      })}
    >
      <S.Container>
        <S.Close>
          <Icon component={CloseIcon} height={12} />
        </S.Close>
        <S.Icon src="/platform/favicon" />
        <S.Details>
          <S.Title>{title}</S.Title>
          <S.Subtitle>App available now!</S.Subtitle>
        </S.Details>
        <S.Button>Install</S.Button>
      </S.Container>
    </ComponentsThemeProvider>
  )
}
